import { makeVar } from '@apollo/client';

/**
 * ТЗ 0074: сервер ответил `LMS_ACCESS_SUSPENDED` на какое-то поле, а свежий
 * `me` с блоком ещё не пришёл.
 *
 * Зачем отдельный флаг, если приостановка и так видна в `me.lmsAccessBlock`.
 * Кеш `me` может быть старым: робот приостановил студента посреди сессии, а
 * страница занятия уже шлёт запросы. Ошибка приходит РАНЬШЕ нового `me`, и без
 * флага страница увела бы студента на `/error`. Флаг ставит errorLink — до того,
 * как ошибку увидит компонент, — и снимает, когда перечитанный `me` лёг в кеш:
 * дальше правду держит уже `me`.
 */
export const accessSuspendedVar = makeVar<boolean>(false);

/**
 * ТЗ 0074: поп-ап неоплаченных фактур сейчас открыт. Опросный поп-ап ждёт,
 * пока его закроют, — два модальных окна одновременно студент не получает.
 */
export const unpaidInvoicesModalOpenVar = makeVar<boolean>(false);
